import { render } from "./NotificationOptionsTable.vue?vue&type=template&id=3d7ab621&scoped=true&ts=true"
import script from "./NotificationOptionsTable.vue?vue&type=script&lang=ts"
export * from "./NotificationOptionsTable.vue?vue&type=script&lang=ts"

import "./NotificationOptionsTable.vue?vue&type=style&index=0&id=3d7ab621&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7ab621"]])

export default __exports__